import {Uchain} from "../redux/api/agent";
import { call, put, takeEvery } from 'redux-saga/effects';
import { sagaActions } from './sagaActions';
import { addSuccess, addFailure,initiateLoading,resetData } from '../redux/reducers/reducerSlices/GetCountryListReducer';
  function* getCountryListRequestHandler(data){
    try{
      yield put(initiateLoading());
     const response = yield call(Uchain.getCountryList);
      yield put(addSuccess(response));
    }catch(error){
     yield put(addFailure(error));
    }
}
export function* GetCountryListRequest() {
  yield takeEvery(sagaActions.GET_COUNTRY_DATA, getCountryListRequestHandler)
}



